module.exports = __webpack_public_path__ + "img/logo.2d6a23a7.svg";